import React, { useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { H3, H5, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../service";
import { useTranslation } from "react-i18next";
import EditProfileModal from "./EdirProfileSection"; // Assuming this modal is correctly implemented
import { Navigate, useNavigate } from "react-router-dom";

const Account = () => {
  const { t } = useTranslation();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const navigate = useNavigate();

  const [userProfile, setUserProfile] = useState({
    name: "Haris",
    role: "Lead Software Architect",
    avatar: "dashboard-8/user3.png",
    email: "Abc@gmail.com",
    phone: "8797654323",
    gender: "Male",
    accountType: "Premium",
    status: "Active",
    city: "New York",
    address: "123 Main St, Anytown USA",
    isEmailVerified: true,
    isPhoneVerified: false,
  });

  const [editProfile, setEditProfile] = useState(userProfile);

  const handleEditChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    setEditProfile((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleEditSave = () => {
    setUserProfile(editProfile);
    setEditModalOpen(false);
  };

  const handleEditClick = () => {
    navigate("/Profile/editprofile")
  };
 

  return (
    <Container fluid>
      <Row>
        <Col xl="12">
          <Card className="mt-4">
            <CardBody>
              {/* Profile Header */}
              <div className="profile-header">
                <Row className="align-items-center">
                  <Col md="auto" className="text-center text-md-start">
                    <Image
                      className="img-100 rounded-circle"
                      alt="profile"
                      src={dynamicImage(userProfile.avatar)}
                    />
                  </Col>
                  <Col className="text-center text-md-start">
                    <H3 className="mb-1 mt-3 mt-md-0">{userProfile.name}</H3>
                    <P className="mb-0 text-muted">{userProfile.role}</P>
                  </Col>
                  <Col md="auto" className="mt-3 mt-md-0 text-center">
                    <Button color="primary" outline onClick={handleEditClick}>
                      <i className="fa fa-pencil me-2"></i>
                      {t("Edit Profile")}
                    </Button>
                  </Col>
                </Row>
              </div>

              <hr />

              <Row className="pt-3">
                {/* Left Side: Profile Information */}
                <Col lg={7} className="mb-4 mb-lg-0">
                  <H5 className="mb-4">Profile Information</H5>
                  <div className="gap-4">
                    <Row className="mb-3">
                      <Col sm={4} className="text-muted">
                        Email
                      </Col>
                      <Col sm={8} className="fw-semibold">
                        {userProfile.email}{" "}
                        {userProfile.isEmailVerified ? (
                          <Badge
                            color="success-light"
                            className="text-success ms-2"
                          >
                            Verified
                          </Badge>
                        ) : (
                          <Badge
                            color="danger-light"
                            className="text-danger ms-2"
                          >
                            Not Verified
                          </Badge>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col sm={4} className="text-muted">
                        Phone
                      </Col>
                      <Col sm={8} className="fw-semibold">
                        {userProfile.phone}{" "}
                        {userProfile.isPhoneVerified ? (
                          <Badge
                            color="success-light"
                            className="text-success ms-2"
                          >
                            Verified
                          </Badge>
                        ) : (
                          <Badge
                            color="danger-light"
                            className="text-danger ms-2"
                          >
                            Not Verified
                          </Badge>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col sm={4} className="text-muted">
                        Account Type
                      </Col>
                      <Col sm={8} className="fw-semibold">
                        {userProfile.accountType}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col sm={4} className="text-muted">
                        Status
                      </Col>
                      <Col sm={8}>
                        <Badge
                          color={
                            userProfile.status === "Active"
                              ? "success"
                              : "danger"
                          }
                        >
                          {userProfile.status}
                        </Badge>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col sm={4} className="text-muted">
                        Gender
                      </Col>
                      <Col sm={8} className="fw-semibold">
                        {userProfile.gender}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col sm={4} className="text-muted">
                        City
                      </Col>
                      <Col sm={8} className="fw-semibold">
                        {userProfile.city}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col sm={4} className="text-muted">
                        Address
                      </Col>
                      <Col sm={8} className="fw-semibold">
                        {userProfile.address}
                      </Col>
                    </Row>
                  </div>
                  
                </Col>

                {/* Right Side: Activity Log Card */}
                <Col lg={5}>
                  <Card className="h-100">
                    <CardHeader>
                      <H5 className="mb-0">Activity Log</H5>
                    </CardHeader>
                    <CardBody>
                      <div className="d-flex flex-column gap-4">
                        {/* Example Activity Item */}
                        <div className="d-flex align-items-center">
                          <div
                            className="activity-icon bg-primary-light text-primary rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: 40, height: 40, flexShrink: 0 }}
                          >
                            <i className="fa fa-sign-in"></i>
                          </div>
                          <div className="ms-3">
                            <P className="mb-0">
                              You logged into your account.
                            </P>
                            <small className="text-muted">
                              2 hours ago from 192.168.1.1
                            </small>
                          </div>
                        </div>
                        {/* Example Activity Item */}
                        <div className="d-flex align-items-center">
                          <div
                            className="activity-icon bg-success-light text-success rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: 40, height: 40, flexShrink: 0 }}
                          >
                            <i className="fa fa-user-circle"></i>
                          </div>
                          <div className="ms-3">
                            <P className="mb-0">
                              Your profile information was updated.
                            </P>
                            <small className="text-muted">5 hours ago</small>
                          </div>
                        </div>
                        {/* Example Activity Item */}
                        <div className="d-flex align-items-center">
                          <div
                            className="activity-icon bg-warning-light text-warning rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: 40, height: 40, flexShrink: 0 }}
                          >
                            <i className="fa fa-key"></i>
                          </div>
                          <div className="ms-3">
                            <P className="mb-0">You changed your password.</P>
                            <small className="text-muted">1 day ago</small>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

    
    </Container>
  );
};

export default Account;
